enum TicketSourceType {
  SOURCE_QUESTION_TYPE = 'Question',
  SOURCE_OTHER_EXTERNAL_TYPE = 'Other - External',
  SOURCE_OTHER_GENERAL_TYPE = 'Other - General',
}

export default TicketSourceType;
